import React from 'react';
import { useIntl } from 'umi';
import './index.scss';

const BAR_VARIANTS = ['lg', 'md', 'sm'] as const;

const AiSearchLoading: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="dbi-ai-search-loading">
      <div className="dbi-ai-search-loading__header">
        <span
          className="dbi-ai-search-loading__icon"
          aria-hidden="true"
        />
        <span className="dbi-ai-search-loading__text">
          {formatMessage({ id: 'dbi_report_search_section_searching' })}
        </span>
      </div>
      <div className="dbi-ai-search-loading__bars">
        {BAR_VARIANTS.map((variant) => (
          <div
            key={variant}
            className={`dbi-ai-search-loading__bar dbi-ai-search-loading__bar--${variant}`}
          />
        ))}
      </div>
    </div>
  );
};

export default AiSearchLoading;
